// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"noteList_wrapper__1wgQ1","listSectionMobile":"noteList_listSectionMobile__D_M6v","listSection":"noteList_listSection__3MGCQ"};